import React from 'react';
import { MeasurementHelper } from '../../../lib/helpers/measurementHelper';

const NumberData: React.FC<{ helper: MeasurementHelper }> = ({ helper }) => (
  <p className="f4 tnum fw5 mv0 blue">
    {helper.aggregate({
      aggregationType: 'sum',
      seriesType: 'sum'
    })}
  </p>
);

export default NumberData;
